<template>
	<WebshopCheckoutPanel>
		<div class="gift-card" :class="{'active': value}">
			<div class="wc-payment-row1">
				<input :name="field.name" :id="field.name + '-1'" :type="field.type" @keyup="onKeyUp($event)" @change="onKeyUp($event)" :checked="field.value" placeholder=" " v-model="value" />
				<label :for="field.name + '-1'"><BaseCmsLabel code="use_value_card" /></label>
			</div>
			<WebshopGiftCard :class="{'active': value}" :data="data" :field="data[1]" />
			<span v-if="info.amount > 0" class="wc-gift-amount">
				<BaseCmsLabel code="gift_card_payment" /> <span><BaseUtilsFormatCurrency :price="info.amount" /></span>
			</span>
		</div>
	</WebshopCheckoutPanel>
	<div v-if="value && totalRemain > 0 && totalRemain != total_regular" class="wc-gift-to-pay" v-html="labels.get('value_card_total_remain').replace('%PRICE%', formatCurrency(totalRemain))"></div>
</template>

<script setup>
	import { useField, defineRule, useValidateForm } from 'vee-validate';

	const {formatCurrency} = useCurrency();
	const labels = useLabels();

	const props = defineProps({
		mode : {
			type: String,
			default: '',
		},
		field: {
			type: null,
			default: false,
		},
		info: {
			type: null,
			default: false,
		},
		data: {
			type: null,
			default: false,
		},
		total: {
			type: null,
			default: false,
		}
	})
	const isDirty = ref(0);

	//gift card amount remain
	const totalRemain = computed(() => props.total.total)
	const total_regular = computed(() => props.total.total_regular)

	// validation rules
	let validationShema = 'related:'+props.field.related_fields+'|'

	// process input
	const { errorMessage, value, resetField } = useField(props.field.name, validationShema, {initialValue: props.field.value})
	let f = props.data
	const fieldIndex = f.findIndex((obj => obj.name == props.field.name))

	// save user input to store and update "valid" property
	const validateForm = useValidateForm();

	async function onKeyUp(event) {
		if(event.key != 'Tab' && event.key != 'Escape') {
			f[fieldIndex].value = value.value;
			isDirty.value = 1;
			await validateForm();
		}
	}

	// clear field on parent checkbox update
	if(props.field.related_fields) {
		const relatedField = props.data?.find(obj => obj.name == props.field.related_fields);
		watch(
			() => relatedField.value,
			() => {
				resetField({value: ''});
				props.data[fieldIndex].value = '';
				isDirty.value = 0;
			}
		)
	}

	// form validation patterns
	defineRule('related', (value, [related], ctx) => {
		if(related == 'use_gift_card' && ctx.form[related]) {
			if (!value || !value.length || value.match(/^ *$/) !== null) {
				return labels.get('error_not_empty');
			}
			return true
		}

		return true
	});
</script>

<style lang="less" scoped>
	.gift-card{
		input[type=checkbox]+label{
			padding: 0; font-weight: bold; font-size: 18px; display: block; position: relative; display: flex; justify-content: space-between; align-items: center;
			@media (max-width: @m){font-size: 16px;}
			&:after{.icon-arrow-down(); font: 10px/1 var(--fonti); margin-left: 15px;}
		}
		input[type=checkbox]+label:before{opacity: 0;}
		&.active{
			.subfields{display: block;}
			input[type=checkbox]+label:after{.scaleY(-1);}
		}
	}
	.subfields{display: none;}
	.wc-gift-amount{
		font-weight: bold; display: flex; justify-content: space-between; padding-bottom: 15px; position: relative; padding-left: 30px;
		@media (max-width: @m){font-size: 14px; margin-top: 10px;}
		&:before{.pseudo(20px,20px); .icon-check(); font: 19px/1 var(--fonti); color: #fff; background: var(--blueDark); border-radius: 4px; display: flex; align-items: center; justify-content: center; left: 0;}
	}
	.wc-gift-to-pay{font-size: 15px; font-weight: bold;}
</style>
